var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loading)?_c('div',{staticClass:"text-center my-8"},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}}),_c('div',{staticClass:"mt-2"},[_vm._v(" Loading article details... ")])],1):(_vm.articleId)?_c('article-details',{staticClass:"mt-2",attrs:{"scope":_vm.scope,"article-id":_vm.articleId}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }